import React from 'react';
import PropTypes from 'prop-types';
import styles from './inline-error-message.scss';
import { InlineAlert } from '@xo-union/tk-component-alerts';

export default class InlineErrorMessage extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['warning', 'error']).isRequired,
    onDismiss: PropTypes.func,
    showSidebar: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    fullWidth: PropTypes.bool,
  };

  render() {
    const { type, onDismiss, children } = this.props;
    return (
      <div className={styles.alertWrapper}>
        <InlineAlert type={type} onCloseButtonClick={onDismiss}>
          {children}
        </InlineAlert>
      </div>
    );
  }
}
